import { RequestStatus, CardCompany, ModalState, PageState, CardList } from '../types';

const APP_NAME = '콤피 페이';

const REQUEST_STATUS: RequestStatus = {
  SUCCESS: 0,
  FAIL: 1,
};

const CARD_EDIT_TARGET_INDEX = {
  NEW: -1,
};

const CARD_COMPANY: Record<number, CardCompany> = {
  1: { name: '포코 카드', color: 'purple', icon: '👾' },
  2: { name: '준 카드', color: 'yellow', icon: '😆' },
  3: { name: '공원 카드', color: 'sky', icon: '🌳' },
  4: { name: '월터 카드', color: 'white', icon: '👻' },
  5: { name: '리트 카드', color: 'white', icon: '🎬' },
  6: { name: '로이 카드', color: 'yellow', icon: '🚀' },
  7: { name: '헤인티 카드', color: 'orange', icon: '🌻' },
  8: { name: '발리스타 카드', color: 'purple', icon: '⭐️' },
  9: { name: '아사 카드', color: 'sky', icon: '🥛' },
  10: { name: '콤피 카드', color: 'green', icon: '🦖' },
};

const DEFAULT_CARD: CardList = [
  {
    id: '1',
    cardName: '기본 카드 1',
    companyId: '4',
    cardNumber: ['1234', '1234', '1234', '1234'],
    expireMonth: '12',
    expireYear: '25',
    userName: 'DEFAULT USER',
    securityCode: '123',
    cardPassword: '23',
  },
  {
    id: '2',
    cardName: '기본 카드 2',
    companyId: '9',
    cardNumber: ['1234', '1234', '1234', '1234'],
    expireMonth: '12',
    expireYear: '25',
    userName: 'DEFAULT USER',
    securityCode: '123',
    cardPassword: '23',
  },
];

const CARD_NUMBER = {
  UNIT_COUNT: 4,
  UNIT_LENGTH: 4,
  MASKING_INDEX: 2,
};

const EXPIRE_DATE = {
  MIN_MONTH: 1,
  MAX_MONTH: 12,
  MONTH_LENGTH: 2,
  YEAR_LENGTH: 2,
  YEAR_UNIT: 2000,
};

const USER_NAME = {
  MAX_LENGTH: 30,
};

const SECURITY_CODE = {
  LENGTH: 3,
};

const CARD_PASSWORD = {
  LENGTH: 2,
};

const MODAL_STATE: Record<string, ModalState> = {
  HIDDEN: 'hidden',
  VISIBLE: 'visible',
  DISAPPEAR: 'disappear',
};

const PAGE_LIST: Record<string, PageState> = {
  CARD_EDITOR: 'edit',
  CARD_UPDATED: 'update',
  CARD_LIST: 'list',
  CARD_PAYMENT: 'payment',
};

const DEFAULT_PAGE = PAGE_LIST.CARD_PAYMENT;

const ERROR_MESSAGE = {
  IS_NOT_VALID_CARD: '카드 정보가 올바르지 않습니다.\n입력한 내용을 확인해주세요.',
  CARD_NUMBER: {
    IS_NOT_LENGTH: `카드번호를 ${
      CARD_NUMBER.UNIT_COUNT * CARD_NUMBER.UNIT_LENGTH
    }자리로 입력해주세요.`,
  },
  EXPIRE_DATE: {
    IS_NOT_INTEGER: '만료일은 숫자로만 입력할 수 있습니다.',
    IS_NOT_VALIDATE_MONTH: '만료월을 정확히 입력해주세요.',
    IS_NOT_MONTH_LENGTH: `만료월을 ${EXPIRE_DATE.MONTH_LENGTH}자리로 입력해주세요.`,
    IS_NOT_YEAR_LENGTH: `만료연도를 ${EXPIRE_DATE.YEAR_LENGTH}자리로 입력해주세요.`,
    IS_EXPIRED: '이미 만료된 카드입니다.',
  },
  USER_NAME: {
    IS_NOT_ENGLISH_NAME: '카드 사용자 이름은 영어와 공백만 입력할 수 있습니다.',
  },
  SECURITY_CODE: {
    IS_NOT_INTEGER: '보안 코드는 숫자로만 입력할 수 있습니다.',
    IS_NOT_LENGTH: `보안 코드를 ${SECURITY_CODE.LENGTH}자리로 입력해주세요.`,
  },
  CARD_PASSWORD: {
    IS_NOT_INTEGER: '비밀번호는 숫자로만 입력할 수 있습니다.',
    IS_NOT_LENGTH: `비밀번호 앞 ${CARD_PASSWORD.LENGTH}자리를 입력해주세요.`,
  },
};

export {
  APP_NAME,
  CARD_EDIT_TARGET_INDEX,
  REQUEST_STATUS,
  CARD_COMPANY,
  DEFAULT_CARD,
  CARD_NUMBER,
  EXPIRE_DATE,
  USER_NAME,
  SECURITY_CODE,
  CARD_PASSWORD,
  MODAL_STATE,
  PAGE_LIST,
  DEFAULT_PAGE,
  ERROR_MESSAGE,
};
